module.exports = __webpack_public_path__ + "static/media/IconeRoboGarconMaps.a12497be.svg";